import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { injectModels } from "../redux/injectModels";
import { toast } from "react-toastify";
//import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import HeaderLogo from "../components/Logo/HeaderLogo";
import { AuthService } from "../services";
import { useDispatch } from "react-redux";
import * as CONSTANTS from "../redux/Models/Application/constants";
import { handleConsoleError } from "../utils/common-methods";
import { globalConstant } from "../constants/globalConstant";

function ChangePassword(props) {
  //const { token } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);

  const togglePassword = () => setShowPassword((prev) => !prev);
  const toggleNewPassword = () => setShowNewPassword((prev) => !prev);
  const toggleCurrentPassword = () => setShowCurrentPassword((prev) => !prev);

  const onSubmit = async (data) => {
    const { currentPassword, newPassword, confirmPassword } = data;

    // Basic validation
    if (!currentPassword || !newPassword || !confirmPassword) {
      toast.error("Please fill all the fields!");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("New Password and Confirm Password must match!");
      return;
    }

    const requestData = {
      oldPassword: currentPassword,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    };

    try {
      props.application.setLoading(true);

      // Making the API call to change the password
      const res = await AuthService.changeUserPassword(requestData);

      if (res?.isSuccess) {
        props.application.setLoading(false);
        toast.success(res?.message || "Password changed successfully");
        dispatch({
          type: CONSTANTS.SET_CURRENT_MODAL,
          payload: CONSTANTS.CLEAR_MODAL,
        });
        navigate("/");
      } else {
        props.application.setLoading(false);
          toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");       
      }
    } catch (error) {
      props.application.setLoading(false);
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  return (
    <React.Fragment>
      <section className="loginswallow">
        <div className="form-container" id="form-container">
          <form id="login-form" onSubmit={handleSubmit(onSubmit)}>
            <HeaderLogo />
            <h3>Change Password</h3>

            <label htmlFor="currentPassword">Current Password</label>
            <div className="password-container">
              <input
                type={showCurrentPassword ? "text" : "password"}
                placeholder="Current Password"
                id="currentPassword"
                {...register("currentPassword", {
                  required: "Current Password is required!",
                })}
              />
              {showCurrentPassword ? (
                <i
                  className="fa-solid fa-eye"
                  id="login-eye"
                  onClick={toggleCurrentPassword}
                ></i>
              ) : (
                <i
                  className="fa-solid fa-eye-slash"
                  id="login-eye"
                  onClick={toggleCurrentPassword}
                ></i>
              )}
            </div>
            {errors.currentPassword && (
              <p className="text-danger">{errors.currentPassword?.message}</p>
            )}

            <label htmlFor="newPassword">New Password</label>
            <div className="password-container">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="New Password"
                id="newPassword"
                {...register("newPassword", {
                  required: "New Password is required!",
                  minLength: {
                    value: 8,
                    message: "Password must be at least 8 characters long",
                  },
                  pattern: {                  
                    value: globalConstant.passwordRegex,
                    message:
                      "Password must contain at least one letter, one number, and one special character.",
                  },
                })}
              />
              {showPassword ? (
                <i
                  className="fa-solid fa-eye"
                  id="login-eye"
                  onClick={togglePassword}
                ></i>
              ) : (
                <i
                  className="fa-solid fa-eye-slash"
                  id="login-eye"
                  onClick={togglePassword}
                ></i>
              )}
            </div>
            {errors.newPassword && (
              <p className="text-danger">{errors.newPassword?.message}</p>
            )}

            <label htmlFor="confirmPassword">Confirm Password</label>
            <div className="password-container">
              <input
                type={showNewPassword ? "text" : "password"}
                placeholder="Confirm Password"
                id="confirmPassword"
                {...register("confirmPassword", {
                  required: "Confirm Password is required!",
                  minLength: {
                    value: 8,
                    message: "Password must be at least 8 characters long",
                  },
                  pattern: {
                    value: globalConstant.passwordRegex,
                    message:
                      "Password must contain at least one letter, one number, and one special character.",
                  },
                })}
              />
              {showNewPassword ? (
                <i
                  className="fa-solid fa-eye"
                  id="login-eye"
                  onClick={toggleNewPassword}
                ></i>
              ) : (
                <i
                  className="fa-solid fa-eye-slash"
                  id="login-eye"
                  onClick={toggleNewPassword}
                ></i>
              )}
            </div>
            {errors.confirmPassword && (
              <p className="text-danger">{errors.confirmPassword?.message}</p>
            )}

            <button type="submit">Change Password</button>
          </form>
        </div>
      </section>
    </React.Fragment>
  );
}

export default injectModels(["admin", "application"])(ChangePassword);
